// extracted by mini-css-extract-plugin
export default {"front":"style_front__zwgKL","card_number":"style_card_number__Iejuj","wrap":"style_wrap__yyqRe","back":"style_back__sXlT1"};